import React, { useState, useEffect } from 'react'
import {
    Button,
    ButtonContainer,
    Container,
    ErrorMessage,
    FFile,
    FInput,
    FInputArea,
    FInputWrapper,
    Header,
    Icon,
    ModalContainer,
    ModalContent,
    OverlayLoading,
    Title
} from '../components/tambahTugas'
import { iconClose } from '../../../../assets'
import API from '../../../../config/api';
import swal from 'sweetalert';
import { Loading } from '../../../../components/atoms';

const ModalCreateUpdate = (props) => {
    const { openModal, handlCLose, employee, data, getTicket, setData, setTypeModal } = props
    const token = localStorage.getItem('token')
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [type, setType] = useState();
    const [formData, setFormData] = useState({
        title: "",
        description: "",
        assign_to: "",
        user_id: employee?.id,
        assign_to: 1
    })

    const [errors, setErrors] = useState({})
    const [images, setImages] = useState([]) // Array of File or URL
    console.log('images', images)
    const handleChange = (e) => {
        const { name, value } = e.target
        setFormData(prev => ({
            ...prev,
            [name]: value
        }))
    }

    const onClose = () => {
        handlCLose()
        setFormData({
            title: "",
            description: "",
            assign_to: "",
            user_id: employee?.id,
            assign_to: 1
        })
        setImages([null])
        setData(null)
        setTypeModal()
    }


    const handleImageChange = (e, index) => {
        const file = e.target.files[0];
        if (file) {
            const newImages = [...images];
            newImages[index] = file;

            // Tambah slot baru kalau di index terakhir
            if (index === images.length - 1) {
                newImages.push(null);
            }
            setLoading(true)
            if (data) {
                const img = images[index];
                console.log('newImages[index]', newImages[index], img)
                const payload = new FormData();
                payload.append('files', newImages[index]);

                if (img) {
                    API.editTicketAttachment(token, img?.id, payload)
                        .then(res => {
                            setImages(prevImages => {
                                const newItem = { id: res?.data?.data?.id, url: res?.data?.data?.url };

                                const exists = prevImages.some(img => img?.id === newItem?.id);

                                if (exists) {
                                    return prevImages.map(img =>
                                        img?.id === newItem?.id ? newItem : img
                                    );
                                } else {
                                    return [...prevImages, newItem];
                                }
                            });
                            setLoading(false)
                            getTicket()
                        })
                        .catch(err => {
                            console.error(err.message);
                            setMessage(err.response?.data?.message || 'Terjadi kesalahan');
                            swal({
                                title: err.response?.status || 'Error',
                                text: err.response?.data?.message || 'Terjadi kesalahan saat mengunggah data',
                                icon: "error",
                            });
                            setLoading(false)
                        });
                } else {
                    API.addTicketAttachment(token, data?.id, payload)
                        .then(res => {
                            const newImage = [...images];
                            newImage[index] = { id: res?.data?.data?.id, url: res?.data?.data?.url };
                            if (index === images.length - 1) {
                                newImage.push(null);
                            }
                            setImages(newImage);
                            setMessage('Gambar Berhasil Ditambahkan');
                            swal({
                                title: 'Berhasil',
                                text: `Sub Section Berhasil Ditambah`,
                                icon: "success",
                            });
                            setLoading(false)
                            getTicket()
                        })
                        .catch(err => {
                            console.error(err.message);
                            setMessage(err.response?.data?.message || 'Terjadi kesalahan');
                            swal({
                                title: err.response?.status || 'Error',
                                text: err.response?.data?.message || 'Terjadi kesalahan saat mengunggah data',
                                icon: "error",
                            });
                            setLoading(false)
                        });
                }
            } else {
                const newImage = [...images];
                newImage[index] = file;

                // Tambah slot baru kalau di index terakhir
                if (index === images.length - 1) {
                    newImage.push(null);
                }

                setImages(newImage)
                setLoading(false)

            }
        }
    };

    const validate = () => {
        const newErrors = {}
        if (!formData.title) newErrors.title = "Title wajib diisi"
        if (!formData.description) newErrors.description = "Deskripsi wajib diisi"
        return newErrors
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        const newErrors = validate();
        setErrors(newErrors);
        if (Object.keys(newErrors).length === 0) {
            setLoading(true)
            const payload = new FormData();
            payload.append('title', formData.title);
            payload.append('description', formData.description);
            payload.append('assign_to', formData.assign_to);
            payload.append('user_id', formData.user_id);

            // Hanya File yang di-upload
            images.filter(img => img instanceof File).forEach((file, i) => {
                payload.append(`files[${i}]`, file);
            });

            if (data) {

                API.editTicket(token, data?.id, payload)
                    .then(res => {
                        setMessage('Data Tugas Berhasil Diupdate');
                        swal({
                            title: 'Berhasil',
                            text: `Sub Section Berhasil Ditambah`,
                            icon: "success",
                        });
                        setLoading(false)
                        handlCLose()
                        handlCLose()
                        setFormData({
                            title: "",
                            description: "",
                            assign_to: "",
                            user_id: employee?.id,
                            assign_to: 1
                        })
                        setImages([])
                        setData(null)
                        getTicket()
                    })
                    .catch(err => {
                        console.error(err.message);
                        setMessage(err.response?.data?.message || 'Terjadi kesalahan');
                        swal({
                            title: err.response?.status || 'Error',
                            text: err.response?.data?.message || 'Terjadi kesalahan saat mengunggah data',
                            icon: "error",
                        });
                        setLoading(false)
                        handlCLose()
                    });
            } else {
                API.addTicket(token, payload)
                    .then(res => {
                        setMessage('Data Tugas Berhasil Ditambahkan');
                        swal({
                            title: 'Berhasil',
                            text: `Sub Section Berhasil Ditambah`,
                            icon: "success",
                        });
                        setLoading(false)
                        handlCLose()
                        handlCLose()
                        setFormData({
                            title: "",
                            description: "",
                            assign_to: "",
                            user_id: employee?.id,
                            assign_to: 1
                        })
                        setImages([])
                        setData(null)
                        getTicket()
                    })
                    .catch(err => {
                        console.error(err.message);
                        setMessage(err.response?.data?.message || 'Terjadi kesalahan');
                        swal({
                            title: err.response?.status || 'Error',
                            text: err.response?.data?.message || 'Terjadi kesalahan saat mengunggah data',
                            icon: "error",
                        });
                        setLoading(false)
                        handlCLose()
                    });

            }

        }
    };

    useEffect(() => {
        if (openModal) {
            document.body.style.overflow = 'hidden';
            document.body.classList.add('hide-scrollbar');

            return () => {
                document.body.style.overflow = '';
                document.body.classList.remove('hide-scrollbar');
            };
        }
    }, [openModal])

    useEffect(() => {
        if (openModal && images.length === 0) {
            setImages([null])
        }
    }, [openModal])

    const handleRemoveImage = (index) => {
        if (type === 'update') {
            const img = images[index];
            setLoading(true)
            // Cek apakah img adalah dari backend (objek dengan id dan url)
            if (data) {
                if (img && typeof img === 'object' && img.id) {
                    API.deleteTicketAttachment(token, img.id).then(res => {
                        // console.log(res)
                        // console.log('oke')
                        const newImages = [...images];
                        newImages.splice(index, 1);

                        if (newImages.length === 0 || newImages[newImages.length - 1] !== null) {
                            newImages.push(null);
                        }

                        setImages(newImages);
                        swal({
                            title: 'Berhasil',
                            text: res.message,
                            icon: "success",
                        });
                        setLoading(false)
                        getTicket()
                    })

                    // Di sini bisa kamu push ke array deletedImageId kalau mau hapus di backend nanti
                    // contoh: setDeletedImages(prev => [...prev, img.id]);
                }
            }
        } else {
            const newImages = [...images];
            newImages.splice(index, 1);

            // Jika tidak ada input kosong di akhir, tambahkan kembali
            if (newImages.length === 0 || newImages[newImages.length - 1] !== null) {
                newImages.push(null);
            }

            setImages(newImages);
        }
    };
    useEffect(() => {
        if (data) {
            setType('update')
            setFormData(prev => ({
                ...prev,
                title: data?.title || '',
                description: data?.description || '',
            }));

            if (data.attachments && Array.isArray(data.attachments)) {
                const imageData = data.attachments.map(item => ({
                    id: item.id,
                    url: item.url
                }));
                setImages([...imageData, null]); // Tambahkan slot kosong
            } else {
                setImages([null]);
            }
        }
    }, [data]);



    return (
        openModal && (
            <ModalContainer>
                <Container>
                    <ModalContent>
                        <Header>
                            <Title>{data ? "Edit" : "Tambah"} Data</Title>
                            <Icon src={iconClose} onClick={onClose} />
                        </Header>

                        <form onSubmit={handleSubmit}>
                            <FInputWrapper>
                                <FInput
                                    name="title"
                                    placeholder="Masukkan title"
                                    value={formData.title}
                                    onChange={handleChange}
                                />
                                {errors.title && <ErrorMessage>{errors.title}</ErrorMessage>}
                            </FInputWrapper>

                            <FInputWrapper>
                                <FInputArea
                                    name="description"
                                    placeholder="Masukkan deskripsi"
                                    value={formData.description}
                                    onChange={handleChange}
                                />
                                {errors.description && <ErrorMessage>{errors.description}</ErrorMessage>}
                            </FInputWrapper>

                            {/* Upload Gambar */}
                            {images.map((img, index) => (
                                <FInputWrapper key={index} style={{ position: 'relative', width: '90%', display: "flex", justifyContent: "left", alignItems: "center" }}>
                                    <FFile
                                        type="file"
                                        accept="image/*"
                                        onChange={(e) => handleImageChange(e, index)}
                                        id={`imageInput-${index}`}
                                    />
                                    <label
                                        htmlFor={`imageInput-${index}`}
                                        style={{
                                            border: '1px dashed #ccc',
                                            padding: '10px',
                                            display: 'flex',
                                            cursor: 'pointer',
                                            minHeight: '100px',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            width: "250px",
                                            position: 'relative'
                                        }}
                                    >
                                        {img ? (
                                            // Tampilkan File atau Gambar dari Backend
                                            img instanceof File
                                                ? <img src={URL.createObjectURL(img)} alt={`Preview-${index}`} style={{ maxWidth: '100%', maxHeight: '150px' }} />
                                                : <img src={img.url} alt={`Preview-${index}`} style={{ maxWidth: '100%', maxHeight: '150px' }} />
                                        ) : (
                                            '+ Pilih Gambar'
                                        )}
                                    </label>
                                    {img && (
                                        <button
                                            type="button"
                                            onClick={() => handleRemoveImage(index)}
                                            style={{
                                                top: 0,
                                                right: 0,
                                                background: 'red',
                                                color: '#fff',
                                                border: 'none',
                                                cursor: 'pointer'
                                            }}
                                            title="Hapus Gambar"
                                        >
                                            Hapus
                                        </button>
                                    )}
                                </FInputWrapper>
                            ))}


                            <ButtonContainer>
                                <Button type="submit">Simpan</Button>
                            </ButtonContainer>
                        </form>
                    </ModalContent>
                    <OverlayLoading loading={loading}>
                        {loading && <Loading />}
                    </OverlayLoading>
                </Container>
            </ModalContainer>
        )
    )
}

export default ModalCreateUpdate
